export function createFractalWorker() {
  return new Worker(new URL('./fractal.worker.js', import.meta.url), { type: 'module' });
}
